const toDataUri = (file: File): Promise<string | null> => {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();

		fileReader.readAsDataURL(file);

		fileReader.onload = () => {
			resolve(fileReader.result?.toString() ?? null);
		};

		fileReader.onerror = (error) => {
			reject(error);
		};
	});
};

export default toDataUri;
